import { useState } from 'react';

import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';

import Button from '../../../../../components/buttons/Button';
import { DialogContent } from '../../../../../components/Dialog/DialogUiRedesign/DialogContent';
import { DialogHeader } from '../../../../../components/Dialog/DialogUiRedesign/DialogHeader';
import type { WizardChildProps } from '../../../../../components/Wizard/types';
import { useStores } from '../../../../../stores/useStores';
import type { SofWizardStepFactory } from '../../types';

import documentImage from './documentImage.svg';
import styles from './InitSofView.module.scss';

export const initSofViewFactory: SofWizardStepFactory = ({ stepsMapping }) => {
  return observer(function InitSofView(props: WizardChildProps) {
    const { t } = useTranslation();
    const { sofStore } = useStores();
    const [requestingToken, setRequestingToken] = useState(false);

    return (
      <>
        <DialogHeader title={t('sof.initTitle')} titleClassName={styles.header} />
        <DialogContent className={styles.container}>
          <p className={styles.primaryText}>{t('sof.pleaseUploadStatement')}</p>
          <img alt="document icon" className={styles.image} src={documentImage} />
          <p className={styles.secondaryText}>{t('sof.securityNote')}</p>
          <Button
            btnType="main"
            className={styles.okButton}
            disabled={requestingToken}
            onClick={async () => {
              setRequestingToken(true);
              try {
                await sofStore.logIn();
                props.forceStep(stepsMapping.process);
              } catch {
                props.forceStep(stepsMapping.issue);
              } finally {
                setRequestingToken(false);
              }
            }}
          >
            {t('common.letsDoIt')}
          </Button>
        </DialogContent>
      </>
    );
  });
};
